/* global machine_logic */
import * as cc_helpers from "./configChecker_helpers";
import helpers from "./helpers.js";
import { defineCssRule } from './style.js';
import configCheckerPersistency from './configCheckerPersistency.js';
import { isMachineMotionRunning } from './models.js';

const formatAxisType = (pType) => {
  switch (pType) {
    case "belt"                       : return "Timing Belt";
    case "enclosed_timing_belt"       : return "Enclosed Timing Belt";
    case "rack_and_pinion"            : return "Rack & Pinion";
    case "rack_and_pinion_v2"         : return "Rack & Pinion v2";
    case "ball_screw"                 : return "Ball Screw";
    case "enclosed_ball_screw"        : return "Enclosed Ball Screw";
    case "enclosed_lead_screw"        : return "Enclosed Lead Screw";
    case "indexer"                    : return "Rotary Actuator v1";
    case "indexer_v2"                 : return "Rotary Actuator v2";
    case "electric_cylinder"          : return "Electric Cylinder";
    case "belt_conveyor"              : return "Belt Conveyor";
    case "roller_conveyor"            : return "Roller Conveyor";
    case "pneumatic"                  : return "Pneumatic";
    case "pneumatic_bag_gripper"      : return "Bag Gripper";
    case "belt_rack"                  : return "Belt Rack";
    case "heavy_duty_roller_conveyor" : return "Heavy-Duty Roller Conveyor";
    case "timing_belt_conveyor"       : return "Timing Belt Conveyor";
    case "telescopic_column"          : return "Telescopic Column";
    case "crx10ia"                    : return "Fanuc CRX-10iA";
    case "crx10ial"                   : return "Fanuc CRX-10iAL";
    case "ur3_e"                      : return "UR 3e";
    case "ur5_e"                      : return "UR 5e";
    case "ur10_e"                     : return "UR 10e";
    case "ur16_e"                     : return "UR 16e";
    case "doosan_h2515"               : return "Doosan h2515";
    case "doosan_h2017"               : return "Doosan h2017";
    case "ac_motor_with_vfd"          : return "AC Motor";
    case "custom"                     : return "Custom";
    default                           : return pType;
  }
};

const buttonColors = {
  red: 'rgba(230, 37, 37, 1)',
  blue: 'rgba(0, 74, 230, 1)'
};

/*global _style*/
/*machine_logic*/
let estopManager;
function setEstopManager (pEstopManager) {
  estopManager = pEstopManager;
}
// -------------------------------------------------------
// Config Checker Css
// -------------------------------------------------------
// Note (AJ): Some of the styles are applied directly to html elements, so for now keeping these styles locally within config checker will avoid ui bugs
function applyStyles() {
  defineCssRule(".cc_header", "font-weight: bold; font-size: 24px; line-height: 29px; margin-top: 15px; margin-bottom: 10px;");
  defineCssRule(".cc_config_header", "font-weight: bold; font-size: 20px; line-height: 24px;");
  defineCssRule(".cc_body", "font-size: 14px; line-height: 17px;");
  defineCssRule(".cc_button_style", "background: #1C344F; border-radius: 3px; color: white; font-size: 14px; line-height: 17px; min-height: 41px; border: none;");
  // buttons
  defineCssRule('.step-section:empty', "display: none;");
  defineCssRule('.default_button_style', 'background: transparent; color: #1C344F; border: 1px solid #EFF2F7;');
  defineCssRule('.yes_button_style', 'background: #1C344F; color: white; border: none;');
  defineCssRule('.no_button_style', 'color: #1C344F; border: 1px solid #EFF2F7');
  defineCssRule('.green_button_style', 'background: #1AC876; color: white; border: none;');
  defineCssRule('.disabled_button', 'filter: opacity(50%); cursor: default !important;');
  defineCssRule('.selected_button', 'border-color: #1C344F !important;');
  defineCssRule('.cc_center', 'display: flex; justify-content: center; align-items: center;');

  defineCssRule('.add_scrollbar', 'height: 100%; overflow-y: auto;');
  defineCssRule('.add_scrollbar::-webkit-scrollbar', 'display:block; width: 20px;');
  defineCssRule('.add_scrollbar::-webkit-scrollbar-track', 'border-radius: 10px;');
  defineCssRule('.add_scrollbar::-webkit-scrollbar-thumb', 'background-color:#D4D7DD; border-radius: 5px;');


  defineCssRule('.ml_cc_modal', 'position: absolute; width: 730px; padding: 8px; border-radius: 4px; background-color: white; box-shadow: 0px 4px 14px rgba(0, 0, 0, 0.2); overflow: hidden; display: flex; flex-direction: column; align-items: center;');

  //Spinner
  defineCssRule('.loader, .loader:after', 'border-radius: 50%; width: 8em; height: 8em;');
  defineCssRule('.loader', 'margin: 30px auto; font-size: 10px; position: relative; text-indent: -9999em; border: 0.5em solid rgba(28,52,79, 0.2); border-right: 0.5em solid rgba(28,52,79, 0.2); border-bottom: 0.5em solid rgba(28,52,79, 0.2); border-left: 0.5em solid #1c344f; -webkit-transform: translateZ(0); -ms-transform: translateZ(0); transform: translateZ(0); -webkit-animation: load 1.1s infinite linear; animation: load 1.1s infinite linear;');
  defineCssRule('@keyframes load ', '0% { -webkit-transform: rotate(0deg); transform: rotate(0deg); } 100% { -webkit-transform: rotate(360deg); transform: rotate(360deg); }');

  //estop
  defineCssRule('.estop_step', 'display: grid; grid-template-columns: 1fr 0.5fr; gap: 1rem; align-items: center; margin-bottom: 13px;');


  //Problemlog css
  defineCssRule(".cc-problem-log", "display: grid; border-collapse: collapse; grid-template-columns: repeat(2, minmax(min-content, max-content));"); // see https://css-tricks.com/preventing-a-grid-blowout/
  defineCssRule(".cc-problem-log thead, .cc-problem-log tbody, .cc-problem-log tr","display: contents;"); // th and td participate in root grid by skipping over the aforementioned containers and making their child elements children of the root grid
  defineCssRule(".cc-problem-log th, .cc-problem-log td", "padding-left: 17px; padding-right: 16px; font-size: 13px;"); // hack. Really we want column-gap: 16px; on the table and padding-left/right: 1px; here, but the tr background does not apply to grid gaps, so we are forced to pad the cells instead
  defineCssRule(".cc-problem-log th:first-child", "padding-left: 1px;"); // first column padding
  defineCssRule(".cc-problem-log > tbody > tr > td:nth-of-type(1)", "padding-left: 1px;"); // first column padding
  defineCssRule(".cc-problem-log th", "font-weight: 700px; text-align: left;");
}

// --------------------------------------------------
// WIDGETS
// --------------------------------------------------

function validationStepsWidget() {
  function getStepIcon(number, result, pending, active) {
    const lWidget = $('<div>').css({height: '25px', minWidth: '25px', borderRadius: '25px', fontSize: '13px', boxSizing: 'border-box', display: 'flex', justifyContent: 'center', alignItems: 'center',});
    if (pending) {
      lWidget.text(number);
      lWidget.css({color: 'white', background: '#F4B73A', fontSize: '13px'});
    } else if (result) {
      lWidget.css({fontSize: '25px'});
      if (result.status == 'passed') {
        lWidget.append($('<div>').addClass('icon-check-filled'));
        lWidget.css({color: '#1AC876'});
      }
      else if (result.status ==  'failed') {
        lWidget.append($('<div>').addClass('icon-close-filled'));
        lWidget.css({color: 'red'});
      }
      else {
        lWidget.append($('<div>').addClass('icon-close-filled'));
        lWidget.css({color: 'red'});
      }
    } else {

      lWidget.text(number).css({background: active ? '#1C344F' : '#EFF2F7', color: active ? 'white' : '#1C344F'});
    }
    return lWidget;
  }

  const generateStepHtml = ({ number, name, result, pending, active, isLast}) => {
    const lStepWidget = $('<div>').addClass('step').css({display: 'flex'});

    getStepIcon(number, result, pending, active).appendTo(lStepWidget);

    const lStepName = $('<div>').text(name).appendTo(lStepWidget);
    lStepName.css({marginLeft: '8px', fontSize: '15px', color: '#1C344F', fontWeight: active ? 'bold' : 'normal'});

    const lLine = $('<div>').css({height: '20px', width: '2px', background: '#EFF2F7', left: '11.4px', position: 'relative'});

    const lWidget = isLast ? lStepWidget : $('<div>').append([lStepWidget, lLine]);
    return lWidget.addClass('step_widget');
  };

  const validationStepContainer = $('<div>').css({display: 'flex', flexDirection: 'column', marginTop: '25px'});

  return {
    element: validationStepContainer,
    update: ({ planningStepInfo = { result: { status: 'passed' }, active: false }, testPlanInfo }) => {
      validationStepContainer.find(".step_widget").remove();

      validationStepContainer.append(
        generateStepHtml({
          number: 1,
          name: "Planning",
          result: planningStepInfo.result,
          active: planningStepInfo.active,
          isLast: testPlanInfo.length == 0,
        }));

      testPlanInfo.forEach( ({ testDef, result, active = false, pending = false, }, i) => {
        validationStepContainer.append(
          generateStepHtml({
            number: i + 2,
            name: testDef.friendlyName,
            result: result,
            pending: pending,
            active: active,
            isLast: i + 1 == testPlanInfo.length
          }));
      });

    },
  };
}

function stepInfoHeaderWidget(pRestartTestHandler) {
  const lContainer = $('<div>').css({margin: '8px', padding: '8px', background: '#EFF2F7'});
  const lWidget = $(`<div>`).css({display: 'flex', justifyContent: 'space-between', alignItems: 'center'}).appendTo(lContainer);
  const lStepInfo = $('<div>').appendTo(lWidget);


  const lStepNumber = $('<div>').css({fontWeight: 'bold', fontSize: '20px'}).appendTo(lStepInfo);
  const lStepInfoRow2 = $('<div>').css({display: 'flex', alignItems: 'center'}).appendTo(lStepInfo);
  const lStepName = $('<div>').appendTo(lStepInfoRow2).css({fontSize: '14px'});
  const lStepInfoTooltipIcon =  $('<div>').addClass('icon-help').css({fontSize: '13px', marginLeft: '5px', cursor: 'pointer'}).appendTo(lStepInfoRow2);

  let lTestDesc;

  const lStepInfoTooltipDiv = $('<div>').css({ width: '300px', background: 'white', border: '1px solid #EFF2F7', boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.15)', borderRadius: '3px', position: 'absolute', top: '80px', left: '300px', display: 'none', padding: '10px'});
  lStepInfoRow2.append(lStepInfoTooltipDiv);
  $('<div>').text('x').css({position: 'absolute', top: '0px', right: '5px', cursor: 'pointer', fontSize: '14px'}).appendTo(lStepInfoTooltipDiv).on('click', () => { lStepInfoTooltipDiv.css({display: 'none'}); }); // close tooltip button
  const lStepInfoTooltipText = $('<div>').css({fontSize: '12px'}).appendTo(lStepInfoTooltipDiv);
  $('<span>').text('Step Info:').css({fontWeight: 'bold', marginRight: '5px'}).appendTo(lStepInfoTooltipText);
  const lStepDesc = $('<span>').appendTo(lStepInfoTooltipText);

  lStepInfoTooltipIcon.on('click', () => {
    lStepInfoTooltipDiv.css({display: 'block'});
    lStepDesc.text(lTestDesc);

    const lRemoveDivCallback = (e) => {
      if (!lStepInfoTooltipDiv.is(e.target) && lStepInfoTooltipDiv.has(e.target).length === 0) {
        lStepInfoTooltipDiv.css({display: 'none'});
        $(document).off('mouseup', lRemoveDivCallback);
      }
    };

    $(document).on('mouseup', lRemoveDivCallback);

  });

  // Restart Test Button
  const lRestartButton = $('<button>').css({
    height: '30px', width: '100px', background: 'white', border: '1.7px solid #1C344F',
    borderRadius: '4px', fontSize: '14px', display: 'flex', justifyContent: 'center', alignItems: 'center'
  }).text('Restart Step').appendTo(lWidget);

  let lActiveTestNumber;

  lRestartButton.on('click', () => {
    if (isMachineMotionRunning) { _style.messageBox('Cannot restart, motion in progress', 'error'); }
    else { pRestartTestHandler(lActiveTestNumber); }
  });

  const estopStatePollingInterval = setInterval(function() { estopManager.getLastEstopState(); }, 500);

  lContainer.on('remove', () => { estopStatePollingInterval && clearInterval(estopStatePollingInterval); });

  return {
    element: lContainer,
    update: ({ name, number, desc }) => {
      lActiveTestNumber = number;
      lStepNumber.text(`Step ${number}`);
      lStepName.text(name);
      if (desc != undefined) { lTestDesc = desc; }

      if (number == 1) {
        lRestartButton.css({display: 'none'});
        lStepInfoTooltipIcon.css({display: 'none'});
      }
      else {
        lRestartButton.css({display: 'flex'});
        lStepInfoTooltipIcon.css({display: 'block'});
      }
    },
  };
}

function testResultWidget() {
  const lResultWidget = $('<div>').css({'display': 'flex', 'flex-direction': 'column', 'align-items': 'center' });
  const lHeader = $(`<div>`).css({display: 'flex', alignItems: 'center'}).appendTo(lResultWidget);
  const lBody = $(`<div>`).addClass('cc_body').appendTo(lResultWidget);
  const lResultTitle = $('<div>').appendTo(lHeader).addClass('cc_header');
  const lResultHeaderIcon = $('<div>').css({marginLeft: '5px', paddingTop: '5px'}).appendTo(lHeader);


  return {
    element: lResultWidget,
    update: (result) => {
      let lTitle;
      let lIconColor;
      if (result.status == 'passed') {
        lTitle = "Test passed"; lIconColor = "#1AC876";
        lResultHeaderIcon.addClass('icon-check-filled');
      } else if (result.status == 'failed') {
        lTitle = "Test Failed"; lIconColor = "#D9534F";
        lResultHeaderIcon.addClass('icon-close-filled');
      } else if (result.status == 'autofix') {
        lTitle = "Automatically fixed"; lIconColor = "#F4B73A";
        lResultHeaderIcon.addClass('icon-check-filled');
      } else {
        lTitle = "Inconclusive"; lIconColor = "grey";
      }

      lResultTitle.text(lTitle);
      lResultHeaderIcon.css({color: lIconColor});
      lBody.append(result.message);
    },
    addWidget: (pWidget) => {
      lResultWidget.append(pWidget);
    }
  };
}

function testDiagnosisWidget(pMlConfig) {
  const lDiagnosisWidget = $('<div>');
  const lProblemsContainer = $('<div>').appendTo(lDiagnosisWidget);
  const lResolutionContainer = $('<div>').appendTo(lDiagnosisWidget);

  const lTestDiagnosisObj = {};

  lTestDiagnosisObj.element = lDiagnosisWidget;

  lTestDiagnosisObj.update = (pResult) => {
    const lError = pResult.lError;
    const lResolution = pResult.resolution;

    lProblemsContainer.append($('<div>').text('Test Failed').addClass('cc_header').css({display: 'flex', alignItems: 'center'})
      .append($('<div>').append($('<div class="icon-close-filled">').css({color: 'red', marginLeft: '5px'}))));

    lProblemsContainer.append($('<div>').text(lError).addClass('cc_body'));


    if (lResolution.type != 'eStop') {
      lResolutionContainer.append($('<div>').text('Suggestions').addClass('cc_header'));
      if (lResolution.description) {
        if (Array.isArray(lResolution.description)) {
          lResolution.description.forEach(msg => {
            lResolutionContainer.append($('<div>').text(msg).addClass('cc_body'));
          });
        } else {
          lResolutionContainer.append($('<div>').text(lResolution.description).addClass('cc_body'));
        }
      }
    }

    if (lResolution.type == 'config') {
      lResolutionContainer.append(getOpenDriveSettingsButton(lResolution.description, pMlConfig));
    }
    else if (lResolution.type == 'eStop') {
      const lEstopMenu = eStopResolutionMenu();
      lEstopMenu.update(lResolution.message);
      lResolutionContainer.append(lEstopMenu.element);
      lTestDiagnosisObj.cleanup = lEstopMenu.cleanup;
    }
  };

  lTestDiagnosisObj.cleanup =  () => {};

  return lTestDiagnosisObj;
}

function loadReportPage(pMount, pActuator, pInitialActuatorConfig, pDiagnoses) {
  const lHeader = $('<div>').css({height: '50px', display: "flex", justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px'}).appendTo(pMount);

  getBacktoConfigButton().appendTo(lHeader);
  $('<div>').text('Test Results').addClass('cc_header').css({textAlign: 'center', margin: '0px', width: '100%'}).appendTo(lHeader);
  getDownloadButton(pActuator.parameters.controllerId).appendTo(lHeader);

  const lContent = $('<div>').css({display: 'flex', flexFlow: 'column nowrap', rowGap: '24px', padding: '5px', backgroundColor: '#EFF2F7'}).appendTo(pMount);
  const lTestResultFrame = $('<div>').addClass('add_scrollbar').css({padding: '16px', height: '583px'}).appendTo(lContent);
  // const testResultFrame = $(`<div class="add_scrollbar" style="padding: 16px; background-color: #EFF2F7; height: 583px;"></div>`);

  const lActuatorInfoContainer = $(`<section>`).css({marginBottom: '24px'}).appendTo(lTestResultFrame);
  $(`<h5>`).text('Resulting Configuration').css({margin: '0px', marginBottom: '8px'}).appendTo(lActuatorInfoContainer);
  const actuatorInfo = driveInfoCard();
  $('<div>').append(actuatorInfo.element).appendTo(lActuatorInfoContainer);

  actuatorInfo.update(pActuator, pInitialActuatorConfig, 'auto');

  actuatorInfo.setStatus('validated');


  const lTestSummaryWidget = testSummaryWidget();

  const items = [];
  cc_helpers.listAllValidatables().forEach(pValidatable => {
    let status;
    const lValidatableObj = pActuator[pValidatable];

    if (lValidatableObj.isValid) {
      status = "Validated";
    } else {
      status = "Not Validated";
    }

    let errors = [];
    if (pDiagnoses.length) {
      errors = pDiagnoses.filter( error => error.testNum == (cc_helpers.listAllValidatables().indexOf(pValidatable) + 1) );
    }

    items.push({ friendlyName: lValidatableObj.name, status: status, errors: errors });
  });

  lTestSummaryWidget.update({ items });

  lTestResultFrame.append(lTestSummaryWidget.element);

  const lBackButton = $(`<button>`).addClass('cc_button_style').css({background: '#1AC876', margin: '10px 0px', width: '100%'}).appendTo(lTestResultFrame);
  lBackButton.on('click', ()=>{ cc_helpers.leaveConfigChecker(); }).text('Back to Configuration');
}

function getOpenDriveSettingsButton(message, pMlConfig) {
  const lWidget = $('<div>').css({ width: '100%', height: '85px', display: 'flex', justifyContent: 'center', alignItems: 'center'});
  const lButton = $('<div>').css({ display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: '15px', color: '#1C344F', cursor: 'pointer', border: '1px solid #1C344F', borderRadius: '3px', height: '41px', width: '50%'}).appendTo(lWidget);
  lButton.text('Open drive settings');
  lButton.on('click', () => { window.showDriveSettingsModal(pMlConfig, message); });
  return lWidget;
}

function getBacktoConfigButton() {
  const lBackButton = $('<div>').on('click', ()=>{ cc_helpers.leaveConfigChecker(); }).css({width: '100%', display: 'flex', cursor: 'pointer'});
  $('<i>').addClass('icon-chevron').css({fontSize: '15px', transform: 'rotate(90deg)', marginRight: '10px'}).appendTo(lBackButton);
  $('<div>').text('Back to Configuration').css({fontSize: '15px',}).appendTo(lBackButton);
  return lBackButton;
}

function getDownloadButton(pControllerId) {
  const lDownloadButton = $(`<a download="configCheckerSave.json">`).css({color: 'inherit', textDecoration: 'none'});
  $('<i>').addClass('icon-download-3dmodel').appendTo(lDownloadButton);
  $('<span>').text('Download').css({marginLeft: '5px'}).appendTo(lDownloadButton);
  configCheckerPersistency.getAllResults( pControllerId, (pResult) => {
    lDownloadButton.attr("href", "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(pResult)));
  });
  lDownloadButton.css({ textAlign: "right", fontSize: '15px', lineHeight: '17px', width: '100%' });
  return lDownloadButton;
}

function eStopResolutionMenu() {
  const lWidget = $('<div>')
    .css({ display: 'flex', flexDirection: 'column', rowGap: '40px', margin: '40px 0' });

  const lPutMachineInEStopStep = $('<div>')
    .css({ display: 'flex', justifyContent: 'space-between', columnGap: '20px'})
    .append(
      $('<div>').text('1. Put your machine in E-Stop. Press a physical E-Stop button.'),
      $('<img src="../../vse/images/estop-release.png">').css({ width: '100px' })
    );

  const lConfigCheckerStep = $('<div>');

  const lReleaseEStopStep = $('<div>')
    .css({ display: 'flex', justifyContent: 'space-between', columnGap: '20px'})
    .append(
      $('<div>').text('3. Release all physical E-Stop buttons.'),
      $('<img src="../../vse/images/estop-release.png">').css({ width: '100px' })
    );

  const lResetEStopStep = $('<div>')
    .css({ display: 'flex', justifyContent: 'space-between', columnGap: '20px'})
    .append(
      $('<div>').text('4. When ready, press the blue reset button on your E-Stop module.'),
      $('<img src="../../vse/images/estop-reset.png">').css({ width: '100px' })
    );

  const lStepTwoAndThreeContainer = $('<div>').css({position: 'relative', display: 'flex', flexDirection: 'column', rowGap: '40px'});
  const lDisabledOverlay = $('<div>').css({
    background: 'rgba(255, 255, 255, 0.7)',
    pointerEvents: 'none',
    position: 'absolute',
    height: '100%',
    width: '100%',
  });

  lWidget.append(
    lPutMachineInEStopStep,
    lStepTwoAndThreeContainer.append(
      lDisabledOverlay,
      lPutMachineInEStopStep,
      lConfigCheckerStep,
      lReleaseEStopStep,
      lResetEStopStep,
    )
  );

  function onEstopUpdate(pEstopState) {
    if (pEstopState === estopManager.EstopStateEnum.Released) {
      lDisabledOverlay.show();
    }
    else {
      lDisabledOverlay.hide();
    }
  }

  estopManager.replaceEstopCallback(onEstopUpdate);


  return {
    element: lWidget,
    update: (message) => {
      lConfigCheckerStep.text(`2. ${message}`);
    },
    cleanup: function () {
      estopManager.reconnectEstopModalCallback();
    },
  };
}

function testSummaryWidget() {
  const lResultsWidget = $('<div>');

  return {
    element: lResultsWidget,
    update: ({ items }) => {
      lResultsWidget.empty();
      $('<h5>').text('Results').css({margin: '0px', marginBottom: '8px'}).appendTo(lResultsWidget);
      items.forEach(
        (item) => {
          const lContainer = $('<div>').css({background: 'white', borderRadius: '3px', border: '1px solid #C6C6C6', padding: '8px', marginBottom: '8px'}).appendTo(lResultsWidget);
          const lResult = $('<div>').css({display: 'flex', justifyContent: 'space-between', alignItems: 'center'}).appendTo(lContainer);
          const lDetails = $('<div>').appendTo(lResult);
          getBadge(item.status).appendTo(lResult);
          $("<div>").text(item.friendlyName).css({fontSize: '13px', fontWeight: 'bold', color: '#1C344F'}).appendTo(lDetails);

          if (item.errors && item.errors.length != 0) {
            let isExpanded = false;
            const lDetectedProblemDropdown = $('<div>').css({display: 'flex', cursor: 'pointer'}).appendTo(lDetails);
            const lExpandText = $('<div>').text('See resolved issues').css({fontSize: '13px', color: '#667A99', marginRight: '5px'}).appendTo(lDetectedProblemDropdown);
            const lExpandEcon = $('<i>').addClass('icon-chevron cc_center').css({fontSize: '10px'}).appendTo(lDetectedProblemDropdown);

            const lProblemLogContainer = $('<div>').css({borderRadius: '3px', padding: '8px', background: '#FBFBFB', display: 'none'}).appendTo(lContainer);
            const lProblemLog = problemLogWidget();
            lProblemLog.update(item.errors);
            lProblemLogContainer.append(lProblemLog.element);

            lDetectedProblemDropdown.click(()=>{
              if (isExpanded) {
                lExpandText.text('See resolved issues');
                lExpandEcon.css({transform: 'rotate(0deg)'});
                lProblemLogContainer.css({display: 'none'});
                isExpanded = false;
              }
              else {
                lExpandText.text('Hide resolved issues');
                lExpandEcon.css({transform: 'rotate(180deg)'});
                lProblemLogContainer.css({display: 'block'});
                isExpanded = true;
              }
            });
          }

        });
    }
  };
}

function problemLogWidget() {

  const lProblemLogTable = $(`
    <table class="cc-problem-log">
        <thead>
            <tr>
                <th>Displayed message</th>
                <th>Suggested solution</th>
            </tr>
        </thead>
        <tbody>
        </tbody>
    </table>`);

  const lProblemLogTableBody = lProblemLogTable.find("tbody");

  return {
    element: lProblemLogTable,
    update: ( errors ) => {
      lProblemLogTableBody.empty();

      errors.forEach(error => {
        lProblemLogTableBody.append(
          `<tr>
                    <td>${error.error || error.message}</td>
                    <td>${error.resolution.description}</td>
                </tr>`);
      });

    },
  };
}

const lTooltipsResource = {
  'sensor' : {
    title: 'What is a sensor?',
    desc : "End-of-travel sensors consist of a home and an end sensor. These end-of-travel sensors prevent the actuator's gantry from over-travelling. The home sensor also dictates the zero-position of your actuator.",
    images : ['/sensor_1.jpg', '/sensor_2.jpg'],
  },
  'sensorPort' : {
    title: 'What is a SENSOR port?',
    desc : "Plug your end-of-travel sensor in either the SENSOR A or SENSOR B ports. This will allow the motors to stop whenever the sensor detects a metallic object, such as the actuator's gantry.",
    images : ['/sensor_port.jpg'],
  },
  'sensorJumper' : {
    title: 'What is a sensor jumper?',
    desc : 'The sensor jumper connects to the SENSOR A and SENSOR B port of the motor when no sensors are needed.',
    images : ['/sensor_jumper.jpg'],
  },
  'brake' : {
    title: 'What is a brake?',
    desc : 'A power-off brake is connected between the motor and the actuator. It will prevent the motor from moving whenever power is lost.',
    images : ['/brake.jpg'],
  },
  'motorLight' : {
    title: 'What is a motor light?',
    desc : 'When your motor is connected to the MachineMotion controller, the white light would be on.',
    images : ['/motor_light.jpg'],
  },
  'drivePort' : {
    title: 'What is a DRIVE port?',
    desc : 'Four DRIVE ports are located on the MachineMotion controller. The DRIVE port is where you plug in the motor cable connecting to your motor. Each DRIVE port is associated with a drive number. Drive numbers can be found on the labels above the DRIVE ports. Important note : always put your machine in E-Stop before connecting or disconnecting motor cables.',
    images : ['/drive_port1.jpg', '/drive_port2.jpg'],
  },
};

function getToolTipWidget(pTooltip) {
  const lToolTip =  $('<div>').css({padding: '5px 0px', color: '#A1A1A1', fontSize: '14px', cursor: 'pointer', width: '650px'});
  const lCategory = pTooltip.category;
  const lToolTipInfo = lTooltipsResource[lCategory];
  pTooltip.text ? lToolTip.text(`${pTooltip.text}`) : lToolTip.text(`${lToolTipInfo.title}`);
  lToolTip.append($('<i class="icon-help">').css({marginLeft: '5px'}));

  lToolTip.on('click', () => {
    const lModalContainer = $('<div>', { class: 'ml_modal_container' }).appendTo('body');
    const lModal = $('<div>', { class: 'ml_cc_modal' }).appendTo(lModalContainer);
    const lCloseBtn = $('<div>').addClass('fas fa-times').appendTo(lModal);
    lCloseBtn.css({ position: 'absolute', top: '4px', right: '6px', color: '#E2E2E2', cursor: 'pointer' });
    lCloseBtn.click(()=>{ lModalContainer.remove(); });
    $('<div>').addClass('cc_header').text(`${lToolTipInfo.title}`).appendTo(lModal);
    $('<div>').addClass('cc_body').css({textAlign: 'center'}).text(lToolTipInfo.desc).appendTo(lModal);
    const lImages = $('<div>').css({display: 'flex', justifyContent: 'space-evenly', width: '100%', margin: '20px 0px'}).appendTo(lModal);
    lToolTipInfo.images.forEach(img => {
      const imageSrc = window.getEnvironment().platform === 'pendant' ? `/images/tooltip${img}` : `https://ventionblobs.s3.amazonaws.com/machine-cloud/machine-motion${img}`;
      $('<img>').attr('src', imageSrc).css({ height: '230px', background: 'grey'}).appendTo(lImages);
    });
  });
  return lToolTip;
}


function driveInfoCard() {
  const lInfoCard = $(`<div/>`).css({ background: '#FBFBFB', border: "1px solid #C2C2C2", "box-sizing": "border-box", "border-radius": "3px", display: "flex", padding: '10px' });

  const lAxisIcon = $('<div>').css({fontSize: '22px'}).appendTo(lInfoCard);

  //Content
  const lContent = $('<div>').css({width: '700px', marginLeft: '10px'}).appendTo(lInfoCard);

  function InfoTile(pLabel, pValue, highlight) {
    const lTile = $('<div>');
    $('<div>').text(pLabel).css({fontWeight: 'bold', fontSize: '15px', lineHeight: '18px', color: '#1C344F'}).appendTo(lTile);
    $('<div>').text(pValue).css({fontSize: '14px', lineHeight: '18px', color: highlight ? '#1AC876' : '#2D3A4D'}).appendTo(lTile);
    return lTile;
  }

  return {
    element: lInfoCard,
    update: (pActuator, pInitialActuatorConfig, pHighlight) => {

      lAxisIcon.removeClass().addClass(helpers.getAxisIconFromType(pActuator.parameters.axisType));

      lContent.empty();

      const lRow1 = $('<div>').css({display: 'grid', gridGap: '0.25rem', 'grid-template-columns' : 'repeat(4, 1fr)', width: '95%'}).appendTo(lContent);

      $('<div>').text(pActuator.isMultiDrive() ? 'Motors' : 'Motor').css({fontSize: '16px', fontWeight: '700', color: '1C344F', marginTop: '20px'}).appendTo(lContent);
      const lTableHeaders = $('<div>').css({display: 'grid', gridGap: '0.25rem', 'grid-template-columns' : 'repeat(4, 1fr)', width: '95%', marginTop: '5px'}).appendTo(lContent);
      $('<div>').text('Level').css({fontSize: '14px', fontWeight: '700', color: '1C344F'}).appendTo(lTableHeaders);
      $('<div>').text('Drive Number').css({fontSize: '14px', fontWeight: '700', color: '1C344F'}).appendTo(lTableHeaders);
      $('<div>').text('Motor Direction').css({fontSize: '14px', fontWeight: '700', color: '1C344F'}).appendTo(lTableHeaders);

      // Actuator Information
      // Row 1
      lRow1.append(InfoTile("Name", pActuator.parameters['friendlyName']));
      lRow1.append(InfoTile("Type", formatAxisType(pActuator.parameters['axisType'])));
      let lHighlightSensors = false;
      if (pInitialActuatorConfig != undefined && pHighlight != undefined) {
        if (pHighlight == 'sensors') { lHighlightSensors = true; }
        else if (pHighlight == 'auto' && pActuator.homeport != pInitialActuatorConfig.homeport) { lHighlightSensors = true; }
      }

      lRow1.append(InfoTile('Home Sensor', `Port ${pActuator.homeport}`, lHighlightSensors ));
      lRow1.append(InfoTile('End Sensor', `Port ${pActuator.endport}`, lHighlightSensors ));

      let lHightightDriveNumber;
      let lHighlightDirection;

      if (pInitialActuatorConfig != undefined && pHighlight != undefined) {
        lHightightDriveNumber = false;
        lHighlightDirection = false;

        if (pHighlight == 'direction') { lHighlightDirection = true; }
        else if (pHighlight == 'auto') {
          if(pActuator.driveNumber != pInitialActuatorConfig.driveNumber) { lHightightDriveNumber = true; }
          if(pActuator.parameters.rotation != pInitialActuatorConfig.parameters.rotation) { lHighlightDirection = true; }
        }
      }


      // Parent Drive Information
      const lParentDriveRow = $('<div>').css({display: 'grid', gridGap: '0.25rem', 'grid-template-columns' : 'repeat(4, 1fr)', width: '95%', marginTop: '2px'}).appendTo(lContent);
      $('<div>').text('Parent').css({fontSize: '14px'}).appendTo(lParentDriveRow);
      $('<div>').text(pActuator.driveNumber).css({fontSize: '14px', color: lHightightDriveNumber ? '#1AC876' : '#2D3A4D'}).appendTo(lParentDriveRow);
      $('<div>').text(pActuator.parameters.rotation == 1 ? 'Normal' : 'Reverse').css({fontSize: '14px', color: lHighlightDirection ? '#1AC876' : '#2D3A4D'}).appendTo(lParentDriveRow);
      // Child Drive Information
      pActuator.children.forEach(child => {
        if (pInitialActuatorConfig != undefined && pHighlight != undefined) {
          lHightightDriveNumber = false;
          lHighlightDirection = false;

          if (pHighlight == 'direction') { lHighlightDirection = true; }
          else if (pHighlight == 'auto') {
            const lOldChild = pInitialActuatorConfig.children.find(pOldChild => pOldChild.color == child.color);
            if (lOldChild == undefined) {
              lHightightDriveNumber = true;
              lHighlightDirection = true;
            } else {
              if (child.rotation != lOldChild.rotation) { lHighlightDirection = true; }
            }
          }
        }

        const lChildDriveRow = $('<div>').css({display: 'grid', gridGap: '0.25rem', 'grid-template-columns' : 'repeat(4, 1fr)', width: '95%', marginTop: '2px'}).appendTo(lContent);
        $('<div>').text('Child').css({fontSize: '14px'}).appendTo(lChildDriveRow);
        $('<div>').text(helpers.getAxisNumberFromColor(child.color)).css({fontSize: '14px', color: lHightightDriveNumber ? '#1AC876' : '#2D3A4D'}).appendTo(lChildDriveRow);
        $('<div>').text(child.rotation == 1 ? 'Normal' : 'Reverse').css({fontSize: '14px', color: lHighlightDirection ? '#1AC876' : '#2D3A4D'}).appendTo(lChildDriveRow);
      });

    },
    setStatus: (status) => {
      if (status != undefined) {
        lInfoCard.css({width: 'auto'});
        const lStatusBadge = getBadge(status).css({position: 'absolute', right: '3px', top: '5px'});
        lInfoCard.append($('<div>').css({width: '444px', position: 'relative'}).append(lStatusBadge));
      }
    }
  };
}


function getActuatorResultCard(pActuator, pStatus, pNavigate) {
  const lWidget = $('<div>').css({background: '#EFF2F7', borderRadius: '3px', height: '50px', padding: '17px', margin: '10px 0px'});
  const lStatsContainer = $('<div>').css({display: 'flex', paddingBottom: '10px'}).appendTo(lWidget);
  const lResultContainer = $('<div>').appendTo(lWidget);

  function getStatWidget(label, value, widget, ) {
    const lStatWidget = $('<div>').css({paddingRight: '20px', minWidth: '150px', fontSize: '15px', color: '#1C344F'}).appendTo(lStatsContainer);
    $('<div>').text(label).css({fontWeight: 'bold'}).appendTo(lStatWidget);
    if (widget != undefined) {
      lStatWidget.append(widget);
    } else {
      $('<div>').text(value).appendTo(lStatWidget);
    }
  }

  function getDriveNumber() {
    if (pActuator.isMultiDriveAxis()) {
      const lAllDriveNumbers = [pActuator.getDriveNumber()];
      pActuator.mChildrenDrives.forEach(child => {
        lAllDriveNumbers.push(helpers.getAxisNumberFromColor(child.color));
      });
      return helpers.punctuate(lAllDriveNumbers);
    }
    else {
      return pActuator.getDriveNumber();
    }
  }

  getStatWidget('Name', pActuator.getName());
  getStatWidget('Drive Number(s)', getDriveNumber());
  getStatWidget('Actuator Type', formatAxisType(pActuator.getType()));
  getStatWidget('Status', undefined, getBadge(pStatus.hasConfigChanged === false ? 'validated' : 'not validated').css({width: 'fit-content'}));

  const lHintMessageContainer = $('<div>').css({width: '300px', alignItems: 'center', display: 'flex'}).appendTo(lStatsContainer);
  const lMessage = $('<div>').css({fontSize: '14px', color: '#1C344F', lineHeight: '1.2'}).appendTo(lHintMessageContainer);

  $('<div>').css({flex: '1'}).appendTo(lStatsContainer);

  let lIsExpanded = false;
  const lExpand = $('<i>').addClass('icon-chevron cc_center').css({cursor: 'pointer', fontSize: '14px'}).on('click', () => {
    if (!lIsExpanded) {
      lExpand.css({transform: 'rotate(180deg)'});
      lIsExpanded = true;

      // static widget
      const items = ['Drive number(s)', 'Motion Direction', 'Home sensor', 'End sensor'].map(item => {return { friendlyName: item, status: 'validated' };} );
      const lTestSummaryWidget = testSummaryWidget();
      lTestSummaryWidget.update({ items });

      lWidget.css({height: pStatus.hasConfigChanged ? '285px' : '275px'});
      lResultContainer.append(lTestSummaryWidget.element);

    } else {
      lExpand.css({transform: 'rotate(0deg)'});
      lIsExpanded = false;
      lResultContainer.empty();
      lWidget.css({height: '50px'});
    }
  });

  // I called this a stats button because we put it in a stats container
  // I have no idea what this really is
  function StatsButton(text) {
    return $('<div>')
      .css({
        margin: '15px 20px',
        height: '25px',
        width: '100px',
        background: '#1C344F',
        color: 'white',
        borderRadius: '3px',
        padding: '3px 0px',
        fontSize: '17px',
        textAlign: 'center',
        cursor: 'pointer'
      })
      .text(text)
      // TODO GD This code should ultimately live in the pendant. The VSE should not be aware of the pendant routes
      .on('click', () => pNavigate({ pathname: "/check-config", search: `?uuid=${pActuator.getUUID()}` }));
  }

  if (pStatus.hasConfigChanged !== null) {
    if (pStatus.hasConfigChanged) {
      lStatsContainer.append(
        StatsButton('Re-test'),
      );

      lMessage.text('Configuration has changed since the last Configuration Checker test session. Please revalidate this actuator.');
      $('<i class="icon-warning"></i>')
        .css({
          paddingRight: '10px',
          color: '#F4B73A'
        })
        .insertBefore(lMessage);
    }

    lStatsContainer.append(
      lExpand
    );
  }
  else {
    lStatsContainer.append(
      StatsButton('Test'),
      $('<div>').css({ width: '15px' })
    );
  }

  return lWidget;
}

function getBadge(status) {
  const lBadge = $(`<div style="padding: 1px 8px 0px 8px; border-radius: 3px; height: 20px;"><span style="display: block; font-size: 15px; line-height: 20px;">${helpers.capitalize(status)}</span></div>`); // 1px padding-top accounts for border I think?
  switch (status.toLowerCase()) {
    case "validated":
      return lBadge.css({ "background-color": "#1AC876", color: "white" });
    case "not validated":
      return lBadge.css({ "color": "#A1A1A1", border: "1px solid #A1A1A1" });
    default:
      return lBadge;
  }
}

function spinner() {
  const lContainer = $('<div id="spinner_widget">').css({display: 'flex', flexDirection: 'column', alignItems: 'center'});
  $('<div class="loader">').appendTo(lContainer);
  $('<div>').text('This might take a while').css({fontSize: '12px', fontWeight: '200'}).appendTo(lContainer);

  return {
    element: lContainer,
  };
}


function testStepWidget() {
  const lStepContainer = $(`<div class="step">`).css({display: 'flex', flexDirection: 'column'});

  const lStepInfoContainer = $("<div />").appendTo(lStepContainer);
  const lTitle = $(`<div>`).addClass('cc_header').appendTo(lStepInfoContainer); // format line-break chars
  const lDescription = $(`<div>`).addClass('cc_body').css({marginTop: '6px'}).appendTo(lStepInfoContainer);
  const lWidgetsContainer = $(`<div>`).addClass('cc_body').appendTo(lStepContainer);
  const lButtonGroup = $('<div>').css({display: 'flex', justifyContent: 'space-between', columnGap: '8px', marginTop: '32px'}).appendTo(lStepContainer);

  function getButtonStyleClass(pText) {
    if (['Verify', 'Ok', 'Go'].includes(pText)) { return 'green_button_style'; }
    else if (pText == 'Yes') { return 'yes_button_style'; }
    else if (pText == 'No') { return 'no_button_style'; }
    else { return 'default_button_style'; }
  }

  return {
    element: lStepContainer,
    setTitle: (pText) => {
      lTitle.text(pText);
    },
    setDescription: (pText) => {
      lDescription.text(pText);
    },
    addWidget: (pWidgetElement) => {
      lWidgetsContainer.append(pWidgetElement.element);
      if (lWidgetsContainer.children().length > 0) { // conditional styling
        lWidgetsContainer.css({marginTop: '20px', marginBottom: '5px'});
      }
    },
    addButton: (pText, pCallback) => {
      const lButton = $(`<button class="button" name="${pText}">${pText}</button>`)
        .css({flexGrow: '1', height: '41px', borderRadius: '3px', fontSize: '14px', fontWeight: '700', width: '100%'})
        .addClass(getButtonStyleClass(pText));
      lButton.click(function () {
        lButtonGroup.find("button").each(function() { // disable + mute all buttons in the button div of step
          $(this).prop("disabled", true);
          $(this).unbind("click");
          $(this).addClass('disabled_button');
        });
        lButton.addClass('selected_button');

        pCallback();
      });
      lButtonGroup.append(lButton);
    },
  };
}

class StepWidgets {

  static setLogger(pLogger) {
    this.logger = pLogger;
  }

  static setStepConsumer(cb) {
    this.stepConsumer = cb; // (stepContainer) => any; // called whenever a new step is generated. It should be added to the user visible UI, but this can be controlled by the consumer (can close the floodgates)
  }

  static showInfo({ title, description, group = false }, pAckd) {
    const lStep = testStepWidget();
    if (typeof title === 'function') {
      title = title("Ok");
    }
    lStep.setTitle(title);
    this.logger.log("out: '" + title + "'");
    if (description) { lStep.setDescription(description); }
    lStep.addButton("Ok", () => { this.logger.log("in: click 'Ok'"); pAckd(); });
    this.stepConsumer(lStep, group);
    return lStep;
  }

  static promptAction({ title, description, group = false }, pCompleted) {
    const lStep = testStepWidget();
    if (typeof title === 'function') {
      title = title("Verify");
    }
    lStep.setTitle(title);
    this.logger.log("out: '" + title + "'");
    if (description) { lStep.setDescription(description); }
    lStep.addButton("Verify", () => { this.logger.log("in: click 'Verify'"); pCompleted(); });
    this.stepConsumer(lStep, group);
    return lStep;
  }

  static consentMove({ title, description, group = false }, pConfirmed) {
    const lStep = testStepWidget();
    if (typeof title === 'function') {
      title = title("Go");
    }
    lStep.setTitle(title);
    this.logger.log("out: '" + title + "'");
    if (description) { lStep.setDescription(description); }
    lStep.addButton("Go", () => { this.logger.log("in: click 'Go'"); pConfirmed(); });
    this.stepConsumer(lStep, group);
    return lStep;
  }

  static askPolar({ title, description, group = false, tooltips }, pAnswered) {
    const lStep = testStepWidget();
    if (typeof title === 'function') {
      title = title("Yes", "No");
    }
    lStep.setTitle(title);
    this.logger.log("out: '" + title + "'");
    if (description) { lStep.setDescription(description); }
    lStep.addButton("Yes", () => { this.logger.log("in: click 'Yes'"); pAnswered(true); });
    lStep.addButton("No", () => { this.logger.log("in: click 'No'"); pAnswered(false); });
    if (tooltips) {
      tooltips.forEach(tooltip => lStep.element.append(getToolTipWidget(tooltip)));
    }
    this.stepConsumer(lStep, group);
    return lStep;
  }

  static askChoice({ title, description, group = false, tooltips }, options, pChose) {
    const lStep = testStepWidget();
    if (typeof title === 'function') { // for completeness, but this is useless
      title = title(...options);
    }
    lStep.setTitle(title);
    this.logger.log("out: '" + title + "'");
    if (description) { lStep.setDescription(description); }
    options.forEach(optionText => {
      lStep.addButton(optionText, () => { this.logger.log("in: click '" + optionText + "'"); pChose(optionText); });
    });
    if (tooltips) {
      tooltips.forEach(tooltip => lStep.element.append(getToolTipWidget(tooltip)));
    }
    this.stepConsumer(lStep, group);
    return lStep;
  }
}

class InfoWidget {
  constructor(initialText = "") {
    const lWidget = $('<div>').css({display: 'flex', alignItems: 'center', justifyContent: 'center'});
    const lSpinner = $('<div class="loader">').css({margin: '0px', height: '15px', width: '15px', borderWidth: '2px', marginRight: '10px', borderColor: 'rgba(227, 227, 227, 0.2) rgba(227, 227, 227, 0.2) rgba(227, 227, 227, 0.2) rgb(189, 187, 187)'}).appendTo(lWidget);
    const lTextWidget = $('<div>').appendTo(lWidget);


    this.showSpinner = (value) => {
      lSpinner.css({display: value ? 'block' : 'none'});
    };

    this.setText = (text) => {
      lTextWidget.text(text);
    };

    this.setText(initialText);
    this.element = lWidget;
  }

  update(info, isLoading) {
    this.showSpinner(isLoading);
    this.setText(info);
  }

  unsetText() {
    this.element.text("");
  }
}

class WatchMachineWidget {
  constructor() {
    const lWidget = $('<div>').css({display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '15px 0px'});
    $('<i>').addClass('icon-make-visible').css({color: '#1AC876', fontSize: '23px'}).appendTo(lWidget);
    $('<div>').text('Please watch your machine').css({fontSize: '18px', color: '#1AC876', fontWeight: 'bold', marginLeft: '5px'}).appendTo(lWidget);
    this.element = lWidget;
  }

  show() {
    this.element.css({display: 'flex'});
  }

  hide() {
    this.element.css({display: 'none'});
  }
}

export default {
  validationStepsWidget,
  stepInfoHeaderWidget,
  testResultWidget,
  testDiagnosisWidget,
  loadReportPage,
  getBacktoConfigButton,
  getDownloadButton,
  spinner,
  getToolTipWidget,
  driveInfoCard,
  getActuatorResultCard,
  StepWidgets,
  InfoWidget,
  WatchMachineWidget,
  applyStyles,
  setEstopManager,
};
